<i18n src="./../../i18n/checkout_form.json"></i18n>

<template>
    <div id="form-checkout" class="row p-0 m-0 mt-checkout no-gutters mt-3 pb-4">
        <div class="col-lg-12 mt-product-main-details p-4">
            <p class="font-weight-bold mt-fs-x-large pt-2" v-text="$t('title')"/>
        </div>

        <div class="no-gutters pb-4 ml-2">
            <div class="row p-row no-gutters pl-3">
                <div class="col-auto p-radio align-content-start">
                    <input type="radio" id="formPrivate" name="checkout-form" class="required" value="private" v-model="checkoutForm.type">
                </div>
                <div class="col pl-2">
                    <label class="" for="formPrivate" v-text="$t('data.formPrivate')" />
                </div>
            </div>
            <div class="row p-row no-gutters pl-3">
                <div class="col-auto p-radio align-content-start">
                    <input type="radio" id="formCompany" name="checkout-form" class="required" value="company" v-model="checkoutForm.type">
                </div>
                <div class="col pl-2">
                    <label class="" for="formCompany" v-text="$t('data.formCompany')" />
                </div>
            </div>
        </div>

        <div class="fieldset-wrapper w-100 pl-4 pr-4 pt-0">
            <div class="row">
                <div class="col-lg-6">
                    <p class="mb-2" v-text="$t('data.name')" />
                    <div class="no-gutters">
                        <input class="required form-control" id="name" v-model="checkoutForm.name" :placeholder="$t('data.namePlaceholder')">
                    </div>
                </div>
                <div class="col-lg-6">
                    <p class="mb-2" v-text="$t('data.surname')" />
                    <div class="no-gutters">
                        <input class="required form-control" id="surname" v-model="checkoutForm.surname" :placeholder="$t('data.surnamePlaceholder')">
                    </div>
                </div>
            </div>

            <div v-if="isCompany" class="row align-items-end">
                <div class="col-lg-6">
                    <p class="mb-2" v-text="$t('data.fiscal')" />
                    <div class="no-gutters">
                        <input class="required form-control" id="nip" v-model="checkoutForm.nip" :placeholder="$t('data.fiscalPlaceholder')">
                    </div>
                </div>
                <div v-if="Const.PRIMARY_LOCALE === 'pl'" class="col-lg-6">
                    <div class="no-gutters">
                        <button type="button" class="btn btn-primary mt-product-btn mt-btn-labeled mt-button mt-button-primary p-3 font-weight-bold fiscal-button" v-on:click="fillCompanyInfo()" v-text="$t('form.getData')"></button>
                    </div>
                </div>
            </div>

            <p v-if="isCompany" class="mb-2" v-text="$t('data.companyName')" />
            <div v-if="isCompany" class="no-gutters">
                <input class="required form-control" id="coname" v-model="checkoutForm.coName" :placeholder="$t('data.companyName')">
            </div>

            <p class="mb-2" v-text="$t('data.address')" />
            <div class="no-gutters">
                <input class="required form-control" id="address" v-model="checkoutForm.address" :placeholder="$t('data.addressPlaceholder')">
            </div>

            <p class="mb-2" v-text="$t('data.city')" />
            <div class="no-gutters">
                <input class="required form-control" id="city" v-model="checkoutForm.city" :placeholder="$t('data.cityPlaceholder')">
            </div>

            <p class="mb-2" v-text="$t('data.postal')" />
            <div class="no-gutters">
                <input class="required form-control" id="postal" v-model="checkoutForm.postal" :placeholder="$t('data.postal')">
            </div>

            <p class="mb-2" v-text="$t('data.phone')" />
            <div class="no-gutters">
                <input class="required form-control" id="phone" v-model="checkoutForm.phone" :placeholder="$t('data.phonePlaceholder')">
            </div>

            <p class="mb-2" v-text="$t('data.email')" />
            <div class="no-gutters">
                <input class="required form-control" id="email" v-model="checkoutForm.email" :placeholder="$t('data.emailPlaceholder')">
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import axios from "axios";
    import {Const} from "@/main";

    export default {
        name: "CheckoutForm",
        components: {},
        props: {
            checkoutForm: {}
        },
        data () {
            return {
                locale: this.$i18n.locale
            }
        },
        computed: {
            isCompany() {
                return this.checkoutForm.type === "company"
            }
        },
        mounted() {
            this.checkoutForm.type = "private"
        },
        methods: {
            isCompanyCustomerType() {
                return this.checkoutForm.type === "company"
            },
            validate() {
                let valid = true

                // imie
                if (this.checkoutForm.name.trim() === '') {
                    valid = false
                    $('#name').addClass('invalid-form')
                    $('#name-error').removeClass('d-none')
                    $('#name-error span').text(this.$t('form.required'))
                } else {
                    $('#name').removeClass('invalid-form')
                    $('#name-error').addClass('d-none')
                }

                // nazwisko
                if (this.checkoutForm.surname.trim() === '') {
                    valid = false
                    $('#surname').addClass('invalid-form')
                    $('#surname-error').removeClass('d-none')
                    $('#surname-error span').text(this.$t('form.required'))
                } else {
                    $('#surname').removeClass('invalid-form')
                    $('#surname-error').addClass('d-none')
                }

                // nr telefonu
                if (this.checkoutForm.phone.trim() === '') {
                    valid = false
                    $('#phone').addClass('invalid-form')
                    $('#phone-error').removeClass('d-none')
                    $('#phone-error span').text(this.$t('form.required'))
                } else {
                    var phone = this.checkoutForm.phone.replace(/[^0-9a-zA-Z]/g, "")
                    var phoneReg;
                    if (Const.PRIMARY_LOCALE === 'pl') {
                        phoneReg = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
                    } else if (Const.PRIMARY_LOCALE === 'lt') {
                        phoneReg = /^0[-. ]?\(?([0-9]{3})\)?[-. ]?([0-9]{5})$/;
                    } else {
                        // like PL
                        phoneReg = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
                    }

                    if(!phone.match(phoneReg)) {
                        valid = false
                        $('#phone').addClass('invalid-form')
                        $('#phone-error').removeClass('d-none')
                        $('#phone-error span').text(this.$t('form.invalidPhone'))
                    } else {
                        $('#phone').removeClass('invalid-form')
                        $('#phone-error').addClass('d-none')
                    }
                }

                // email
                if (this.checkoutForm.email.trim() === '') {
                    valid = false
                    $('#email').addClass('invalid-form')
                    $('#email-error').removeClass('d-none')
                    $('#email-error span').text(this.$t('form.required'))
                } else {
                    var emailReg = /\S+@\S+\.\S+/
                    if (!this.checkoutForm.email.toLowerCase().match(emailReg)) {
                        valid = false
                        $('#email').addClass('invalid-form')
                        $('#email-error').removeClass('d-none')
                        $('#email-error span').text(this.$t('form.invalidPhone'))
                    } else {
                        $('#email').removeClass('invalid-form')
                        $('#email-error').addClass('d-none')
                    }
                }

                // adres
                if (this.checkoutForm.address.trim() === '') {
                    valid = false
                    $('#address').addClass('invalid-form')
                    $('#address-error').removeClass('d-none')
                    $('#address-error span').text(this.$t('form.required'))
                } else {
                    $('#address').removeClass('invalid-form')
                    $('#address-error').addClass('d-none')
                }

                // miejscowosc
                if (this.checkoutForm.city.trim() === '') {
                    valid = false
                    $('#city').addClass('invalid-form')
                    $('#city-error').removeClass('d-none')
                    $('#city-error span').text(this.$t('form.required'))
                } else {
                    $('#city').removeClass('invalid-form')
                    $('#city-error').addClass('d-none')
                }

                // kod pocztowy
                if (this.checkoutForm.postal.trim() === '') {
                    valid = false
                    $('#postal').addClass('invalid-form')
                    $('#postal-error').removeClass('d-none')
                    $('#postal-error span').text(this.$t('form.required'))
                } else {
                    var postalReg;

                    if (Const.PRIMARY_LOCALE === 'pl') {
                      postalReg = /^[0-9][0-9]-[0-9][0-9][0-9]$/
                    } else if (Const.PRIMARY_LOCALE === 'lt') {
                      postalReg = /^(?:LT-)?([0-9]{5})$/
                    } else {
                      // like PL
                      postalReg = /^[0-9][0-9]-[0-9][0-9][0-9]$/
                    }
                    if (!this.checkoutForm.postal.trim().match(postalReg)) {
                        valid = false
                        $('#postal').addClass('invalid-form')
                        $('#postal-error').removeClass('d-none')
                        $('#postal-error span').text(this.$t('form.invalidPostal'))
                    } else {
                        $('#postal').removeClass('invalid-form')
                        $('#postal-error').addClass('d-none')
                    }
                }

                // NIP
                if (this.isCompanyCustomerType() && this.checkoutForm.nip.trim() !== '') {
                    if (!this.isValidNip(this.checkoutForm.nip.trim())) {
                        valid = false
                        $('#nip').addClass('invalid-form')
                        $('#nip-error').removeClass('d-none')
                        $('#nip-error span').text(this.$t('form.invalidNip'))
                    } else {
                        $('#nip').removeClass('invalid-form')
                        $('#nip-error').addClass('d-none')
                    }
                }

                // nazwa firmy
                if (this.isCompanyCustomerType() && this.checkoutForm.coName.trim() === '') {
                    valid = false
                    $('#coname').addClass('invalid-form')
                    $('#coname-error').removeClass('d-none')
                    $('#coname-error span').text(this.$t('form.required'))
                } else {
                    $('#coname').removeClass('invalid-form')
                    $('#coname-error').addClass('d-none')
                }

                return valid;
            },
            validateNip() {
                let valid = true
                // NIP
                if (this.checkoutForm.nip.trim() !== '') {
                    if (!this.isValidNip(this.checkoutForm.nip.trim())) {
                        valid = false
                        $('#nip').addClass('invalid-form')
                        $('#nip-error').removeClass('d-none')
                        $('#nip-error span').text(this.$t('form.invalidNip'))
                    } else {
                        $('#nip').removeClass('invalid-form')
                        $('#nip-error').addClass('d-none')
                    }
                }

                return valid;
            },
            isValidNip(fiscalNr) {
                fiscalNr = fiscalNr.replace(/[ -]/g, '');

                if (!/^\d+$/.test(fiscalNr))
                    return false

                if (Const.PRIMARY_LOCALE === 'pl') {
                    return this.validatePLNIP(fiscalNr);
                } else if (Const.PRIMARY_LOCALE === 'lt') {
                    // LT PVM validation
                    return this.validateLTPVM(fiscalNr);
                }

                // Other locales - no validation
                return true
            },
            validatePLNIP(nip) {
                let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
                let sum = 0;
                let controlNumber = parseInt(nip.substring(9, 10));
                let weightCount = weight.length;
                for (let i = 0; i < weightCount; i++) {
                    sum += (parseInt(nip.substr(i, 1)) * weight[i]);
                }

                return sum % 11 === controlNumber;
            },
            validateLTPVM(pvm) {
                pvm = pvm.replace(/[A-Z\s]+/g, '');

                if (!/^\d{9}$|^\d{12}$/.test(pvm)) {
                  return false;
                }

                const length = pvm.length;
                const controlNumber = parseInt(pvm.substring(length - 1, length));

                let weight1, weight2;

                if (length === 9) {
                    weight1 = [1, 2, 3, 4, 5, 6, 7, 8];
                    weight2 = [3, 4, 5, 6, 7, 8, 9, 1];
                } else {
                    weight1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1, 2];
                    weight2 = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3, 4];
                }

                const calculateSum = (str, weights) => {
                    let sum = 0;
                    for (let i = 0; i < weights.length; i++) {
                        sum += parseInt(str.charAt(i)) * weights[i];
                    }
                    return sum % 11;
                };

                let remainder = calculateSum(pvm, weight1);

                if (remainder === 10) {
                    remainder = calculateSum(pvm, weight2);
                    if (remainder === 10) {
                        remainder = 0;
                    }
                }

                return remainder === controlNumber;
            },
            clearClientData() {
                this.checkoutForm.address = ""
                $('#address').val("")
                this.checkoutForm.city = ""
                $('#city').val("")
                this.checkoutForm.postal = ""
                $('#postal').val("")
                this.checkoutForm.nip = ""
                $('#nip').val("")
                this.checkoutForm.coName = ""
                $('#coname').val("")

                $('.mt-checkout .checkout-pane-fiscal input').each(function () {
                    if ($(this).val() === '') {
                        $("label[for='" + $(this).attr('id') + "']").show(200);
                    } else {
                        $("label[for='" + $(this).attr('id') + "']").hide();
                    }
                });
            },
            fillCompanyInfo() {
                if (!this.validateNip()) {
                    return
                }
                let fiscalId = this.checkoutForm.nip.replace(/[ -]/, '');
                axios.get(`${Const.API_HOST}/${this.locale}/company/${fiscalId}/summary`)
                    .then(function (response) {
                        return {
                            status: response.status,
                            body: response.data
                        };
                    }).catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error);
                }).then(resp => {
                    let company = resp.body
                    this.checkoutForm.coName = company.name
                    $('#coname').val(company.name)
                    this.checkoutForm.postal = company.postalCode
                    $('#postal').val(company.postalCode)
                    if (company.street && company.street.trim() !== "") {
                        this.checkoutForm.address = `${company.street} ${company.streetNumber}`
                        if (company.apartmentNumber && company.apartmentNumber.trim() !== "") {
                            this.checkoutForm.address += `, ${company.apartmentNumber}`
                        }
                        $('#address').val(this.checkoutForm.address)
                        this.checkoutForm.city = company.city
                        $('#city').val(company.city)
                    } else {
                        this.checkoutForm.address = `${company.city} ${company.streetNumber}`
                        $('#address').val(this.checkoutForm.address)
                        this.checkoutForm.city = company.postalCity
                        $('#city').val(company.postalCity)
                    }

                    $('.mt-checkout .checkout-pane-fiscal input').each(function () {
                        if ($(this).val() === '') {
                            $("label[for='" + $(this).attr('id') + "']").show(200);
                        } else {
                            $("label[for='" + $(this).attr('id') + "']").hide();
                        }
                    });
                });
            }
        }
    }
</script>

<style scoped>
    .form-error {
        font-size: 0.8rem;
        color: red;
        opacity: 0.7;
    }

    .form-check-input {
        accent-color: #295d92;
        width: 18px;
        height: 18px;
    }

    .mt-checkout {
        background-color: #fff;
        padding-top: 1rem;
        border: 1px solid #e7e7e7;
    }

    .fieldset-wrapper input, .fieldset-wrapper textarea {
        width: 100%;
        height: 50px;
        outline: 0;
        background: #fafafa;
        border: 0;
        border-radius: 0;
        margin: 0 0 15px;
        padding: 25px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        font-size: 14px;
    }

    .p-radio input {
        -ms-transform: scale(1.2); /* IE 9 */
        -webkit-transform: scale(1.2); /* Chrome, Safari, Opera */
        transform: scale(1.2);
    }

    .fiscal-button {
        height: 50px;
        margin-bottom: 15px;
    }
</style>